import TextDotDivider from "../components/TextDotDivider";
import styled from "styled-components";
import {useEffect, useState} from "react";
import dompurify from "dompurify";
import {fetchQuillData} from "../serverAPI";

const Header = styled.p`
  margin-top: 20px;
  font-size: 20px;
  font-family: signika, sans-serif;
  font-weight: bold;
  color: rgb(232, 26, 62);
`;

const OlContainer = styled.ol`
  list-style-type: decimal;
  margin-left: 15px;
`;

const SanitizerInner = styled.div`
  margin-top: 30px;
  margin-left: 40px;

  span {
    line-height: 1.5em;
  }

  ol {
    list-style-type: decimal;
    padding-inline-start: 1.3em;
  }

  li {
    &::marker {
      font-size: 14px;
    }
  }
`;

export default function Publications() {
  const sanitizer = dompurify.sanitize;
  const [internationalPapers, setInternationalPapers] = useState("");
  const [internationalBook, setInternationalBook] = useState("");
  const [internationalAbstracts, setInternationalAbstracts] = useState("");
  const [domesticPapers, setDomesticPapers] = useState("");
  const [domesticAbstracts, setDomesticAbstracts] = useState("");

  useEffect(() => {
    const loadInternationalPapersQuillData = async () => {
      const quillData = await fetchQuillData("internationalPapers");
      setInternationalPapers(quillData);
    };
    const loadInternationalBookQuillData = async () => {
      const quillData = await fetchQuillData("internationalBook");
      setInternationalBook(quillData);
    };
    const loadInternationalAbstractsQuillData = async () => {
      const quillData = await fetchQuillData("internationalAbstracts");
      setInternationalAbstracts(quillData);
    };
    const loadDomesticPapersQuillData = async () => {
      const quillData = await fetchQuillData("domesticPapers");
      setDomesticPapers(quillData);
    };
    const loadDomesticAbstractsQuillData = async () => {
      const quillData = await fetchQuillData("domesticAbstracts");
      setDomesticAbstracts(quillData);
    };

    loadInternationalPapersQuillData();
    loadInternationalBookQuillData();
    loadInternationalAbstractsQuillData();
    loadDomesticPapersQuillData();
    loadDomesticAbstractsQuillData();
  }, []);

  return (<div>
    <TextDotDivider text="International Publications"/>
    <Header>Papers (Underscore : corresponding author(s), #: equal contributions)</Header>
    <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(internationalPapers)}}/>
    <Header>Book Chapter</Header>
    <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(internationalBook)}}/>
    <Header>Meeting Abstracts and Conference Paper</Header>
    <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(internationalAbstracts)}}/>
    <TextDotDivider text="Domestic Publications"/>
    <Header>Papers</Header>
    <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(domesticPapers)}}/>
    <Header>Meeting Abstracts and Conference Paper</Header>
    <SanitizerInner style={{marginBottom: "50px"}} dangerouslySetInnerHTML={{__html: sanitizer(domesticAbstracts)}}/>
  </div>);
}
